module.exports = __webpack_public_path__ + "files/f9880e5300a543347a7fe12a1df5b7f6.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bold-webfont.woff2
 ** module id = 987
 ** module chunks = 0
 **/